import React from 'react';
import PropTypes from 'prop-types';
import Colors from 'common/constants/colors';
import './index.scss';

export default class StoryboardBranding extends React.Component {
  static propTypes = {
    color: PropTypes.string,
    superpartnerFooterLogo: PropTypes.string,
  };

  static defaultProps = {
    color: Colors.white,
    superpartnerFooterLogo: '',
  };

  getBackgroundUrl(color, superpartnerFooterLogo) {
    return superpartnerFooterLogo || `/static/www/logo-atrius.svg`;
  }

  getColor(color, gray800) {
    return color === gray800 ? 'black' : 'white';
  }

  getHeight(superpartnerFooterLogo) {
    // When a superpartner footer logo is present,
    // it should be larger than a regular logo.
    return superpartnerFooterLogo ? '60%' : '40%';
  }

  render() {
    const color = this.getColor(this.props.color, Colors.gray800);
    const backgroundUrl = this.getBackgroundUrl(
      color,
      this.props.superpartnerFooterLogo,
    );
    const height = this.getHeight(this.props.superpartnerFooterLogo);
    return (
      <div
        className={'StoryboardBranding'}
        style={{
          background: `url("${backgroundUrl}") 0 0 / contain no-repeat`,
          height,
        }}
      />
    );
  }
}
